module.exports = __webpack_public_path__ + "static/menschen-bewegen-logo-0f01817c2d1809151de0d96df21891d2.png";